export const localStorageKeyBasicInfo: string = 'basicInfoForm';
export const localStorageKeyInterests: string = 'interestsActivitiesGoalsForm';
export const localStorageKeyInternational: string = 'internationalEducationForm';
export const localStorageKeyResearch = 'researchAndPublicationsForm';
export const localstorageKeyWaitingRoomIds = 'seenAppointmentIds'


export const predefinedKeys = [
  localStorageKeyBasicInfo,
  localStorageKeyInterests,
  localStorageKeyInternational,
  localStorageKeyResearch,
  localstorageKeyWaitingRoomIds,
]